import {ClassValue, clsx} from 'clsx';
import {extendTailwindMerge} from 'tailwind-merge';

const sizes = ['lg', 'md', 'sm'] as const;

const getFontSizeClass = (name: string) => {
  return sizes.map((size) => `${name}-${size}`);
};

const createTailwindMerge = () =>
  extendTailwindMerge({
    extend: {
      classGroups: {
        'font-size': [
          ...getFontSizeClass('text-title'),
          ...getFontSizeClass('text-body'),
          ...getFontSizeClass('text-label'),
          ...getFontSizeClass('text-paragraph'),
        ],
      },
      conflictingClassGroups: {
        'font-size': ['font-weight', 'tracking'],
      },
    },
  });

const twMerge = createTailwindMerge();

export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));
